/* eslint-disable no-await-in-loop */
/* eslint-disable import/no-cycle */
import axios from 'axios';
import _ from 'lodash';

import {
  CustomException,
  // downloadExcel,
  genPickerData,
  getIdToken,
  getListItemsCount,
  isAllResponseValid,
  isResponseValid,
  roundToTwoDecimals,
  throwSAPError,
  // downloadExcel,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  GET_ITEM_LIST_DATA,
  SAVE_ITEM_LIST_DATA,
  GET_ITEM_DATA,
  RESET_ITEM_DATA,
  SET_ITEM_STATUS,
  SET_LIST_STATUS,
  LOAD_FAVOURITE_DATA,
  SET_MATERIAL_GROUP_TABLE_STATUS,
  GET_MATERIAL_GROUP_TABLE_DATA,
  RESET_ITEM_TABLE_LIST_DATA,
} from '../helpers/types';

const invalidResponseMsgText = i18n.t('productScreenTranslations:INVALID_RESPONSE');

export const getSortedList = (list, sortOrder = 'asc') => {
  try {
    return _.orderBy(list, 'SalesPrice', [sortOrder]);
  } catch (err) {
    return list;
  }
};

export const saveItemList = data => ({
  type: SAVE_ITEM_LIST_DATA,
  payload: { itemList: data },
});

export const getItemListData = (
  skip,
  enqueueSnackbar = () => {},
  handlePageChange = () => {},
  filterStr = '',
  field = 'itemList',
  searchFieldsData = []
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth, product } = state;
    const { client, systemIP, selectedSalesOrgData, BusinessPartner } = auth;
    const { SalesOrg, DisCha, ItemProp, Plant, StorageLocation } = selectedSalesOrgData;
    const { top } = product;
    dispatch({
      type: SET_LIST_STATUS,
      payload: { isLoading: true },
    });
    const MainService = axios.create({
      baseURL: `${systemIP}/`,
    });

    const items = {};
    const favorites = {};

    const idToken = await getIdToken(dispatch, getState);

    items.config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}'`,
      },
    };

    if (filterStr !== '') {
      items.config = {
        ...items.config,
        params: {
          ...items.config.params,
          $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and (${filterStr})`,
        },
      };
    }

    const favouratesConfig = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $expand: 'to_Item',
        $filter: `SalesOrganization eq '${SalesOrg}'`,
      },
    };
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_PB2B_SRV/ZAE_I_Material_07`;
      listCount = await getListItemsCount(items.config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      items.config.params = {
        ...items.config.params,
        $top: top,
        $skip: skip,
      };
      items.request = MainService.get('ZAE_PB2B_SRV/ZAE_I_Material_07', items.config);

      favorites.request = MainService.get(
        `ZAE_PB2B_SRV/ZAE_I_ItemProposal(SalesDocument='${ItemProp}')`,
        favouratesConfig
      );
      const response = await axios.all([items.request, favorites.request]).catch(throwSAPError);
      [items.response, favorites.response] = response;

      const { to_Item } = favorites.response.data.d;
      const favouriteList = { ...favorites.response.data.d, to_Item };
      let payload = {};
      if (isAllResponseValid(response)) {
        let data = items.response.data.d.results;
        const favouriteItems = favouriteList.to_Item.results;

        data = data.map(d => {
          let dF = d;
          favouriteItems.forEach(f => {
            if (d.Material === f.Material) {
              dF = { ...dF, favourite: true };
            }
            return dF;
          });
          return dF;
        });

        const stockQuantityRequestsConfig = {
          headers: {
            'AZURE-AUTH': `${idToken}`,
            'X-Requested-With': 'XMLHttpRequest',
          },
          params: {
            'sap-client': client,
          },
        };
        const stockPriceRequestsConfig = {
          headers: {
            'AZURE-AUTH': `${idToken}`,
            'X-Requested-With': 'XMLHttpRequest',
          },
          params: {
            'sap-client': client,
          },
        };

        const qtyItemsIn = data.map(r => ({
          Material: r.Material,
          Plant,
          StorageLoc: StorageLocation,
        }));
        const stockQuantityPayload = {
          N_PB2B_GET_AVL_QTY_INPUT: qtyItemsIn,
          N_PB2B_GET_AVL_QTY_OUTPUT: [],
        };
        const priceItemsIn = data.map((r, i) => {
          let Posnr = `${(i + 1) * 10}`;
          Posnr = Posnr.padStart(6, '0');
          return {
            Posnr,
            HighItem: '000000',
            Material: r.Material,
            Plant,
          };
        });

        const stockPricePayload = {
          N_PB2B_HEADER: [
            {
              Customer: BusinessPartner,
              SalesOrg,
            },
          ],
          N_PB2B_ITEMS_IN: priceItemsIn,
          N_PB2B_ITEMS_OUT: [],
        };
        const stockQuantityResponse = await MainService.post(
          'ZAE_FM_PB2B_GET_AVL_QTY_MULTI_SRV/PB2B_GET_AVL_QTY_INPUTSet',
          stockQuantityPayload,
          stockQuantityRequestsConfig
        ).catch(err => console.log(err));

        const stockPriceResponse = await MainService.post(
          'ZAE_FM_PB2B_SIMULATE_GET_PRICE_SRV/ZAE_FM_PB2B_SIMULATE_GET_PRICESet',
          stockPricePayload,
          stockPriceRequestsConfig
        ).catch(err => console.log(err));
        data = data.map(d => ({
          ...d,
          StockQuantity: undefined,
          StockQuantityUOM: undefined,
          SalesPrice: undefined,
          SalesPriceUnit: undefined,
        }));
        data = data.map(d => {
          let dF = d;
          try {
            const stockResults =
              stockQuantityResponse !== undefined
                ? stockQuantityResponse.data.d.N_PB2B_GET_AVL_QTY_OUTPUT.results
                : [];
            if (stockResults.length > 0) {
              const fD = stockResults.find(s => s.Material === dF.Material);
              dF = {
                ...dF,
                checked: false,
                ConditionQuantity: '1',
                ConditionQuantityUnit: 'EA',
                StockQuantity: parseInt(fD.AvlQty, 10),
                StockQuantityUOM: fD.Uom,
              };
            } else {
              dF = {
                ...dF,
                checked: false,
                ConditionQuantity: '1',
                ConditionQuantityUnit: 'EA',
                StockQuantity: undefined,
                StockQuantityUOM: undefined,
              };
            }
            return dF;
          } catch (err) {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              StockQuantity: undefined,
              StockQuantityUOM: undefined,
            };
            return dF;
          }
        });
        data = data.map(d => {
          let dF = d;
          try {
            const priceResults = stockPriceResponse.data.d.N_PB2B_ITEMS_OUT.results;
            if (priceResults.length > 0) {
              const pD = priceResults.find(s => s.Material === dF.Material);
              dF = {
                ...dF,
                checked: false,
                ConditionQuantity: pD.ReqQty,
                ConditionQuantityUnit: pD.SalesUnit,
                SalesPrice: roundToTwoDecimals(pD.GrossPrice),
                SalesPriceUnit: pD.Currency, // TODO: Get Currency from Price FM
                Tax: pD.Tax,
              };
            } else {
              dF = {
                ...dF,
                checked: false,
                ConditionQuantity: '1',
                ConditionQuantityUnit: 'EA',
                SalesPrice: undefined,
                SalesPriceUnit: undefined,
                Tax: undefined,
              };
            }
            return dF;
          } catch (err) {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              SalesPrice: undefined,
              SalesPriceUnit: undefined,
              Tax: undefined,
            };
            return dF;
          }
        });

        data = getSortedList(data);
        if (field === 'itemTableList') {
          data = data.map(d => ({
            ...d,
            Quantity: searchFieldsData.find(
              s =>
                s.Material === d.Material ||
                d.Material.includes(s.Material) ||
                d.Material.includes(s.Material.toUpperCase()) ||
                d.Material.includes(s.Material.toLowerCase())
            ).Quantity,
          }));
        }
        payload = {
          itemList: data,
          listCount,
          failText: data.length === 0 ? i18n.t('productScreenTranslations:NO_PRODS_FOUND') : '',
          field,
        };
        handlePageChange();
        dispatch({
          type: GET_ITEM_LIST_DATA,
          payload,
        });
        dispatch({
          type: LOAD_FAVOURITE_DATA,
          payload: { list: favouriteItems },
        });
      } else {
        throw new CustomException(invalidResponseMsgText);
      }
    }
  } catch (error) {
    enqueueSnackbar(`${i18n.t('productScreenTranslations:UNABLE_TO_LOAD_PRODUCTS_DATA')}`, {
      variant: 'error',
    });
    dispatch({
      type: GET_ITEM_LIST_DATA,
      payload: {
        itemList: [],
        listCount: 0,
        failText: i18n.t('productScreenTranslations:UNABLE_TO_LOAD_PRODUCTS_DATA'),
      },
    });
    dispatch({
      type: SET_LIST_STATUS,
      payload: {
        isLoading: false,
      },
    });
  }
};

export const getItemData = item => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData, BusinessPartner } = auth;
    const { Plant, SalesOrg, StorageLocation } = selectedSalesOrgData;
    dispatch({
      type: SET_ITEM_STATUS,
      payload: { isItemLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `Material eq '${item}'`,
      },
    };
    const stockQuantityRequestsConfig = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        'sap-client': client,
      },
    };
    const stockPriceRequestsConfig = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        'sap-client': client,
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}`,
    });
    const response = await MainService.get('/ZAE_PB2B_SRV/ZAE_I_Material_07', config).catch(e => {
      console.log('err', e.toString());
    });
    if (isResponseValid(response)) {
      let data = response.data.d.results[0];

      const qtyItemsIn = [
        {
          Material: data.Material,
          Plant,
          StorageLoc: StorageLocation,
        },
      ];
      const stockQuantityPayload = {
        N_PB2B_GET_AVL_QTY_INPUT: qtyItemsIn,
        N_PB2B_GET_AVL_QTY_OUTPUT: [],
      };
      let Posnr = `10`;
      Posnr = Posnr.padStart(6, '0');
      const itemInData = [
        {
          Posnr,
          HighItem: '000000',
          Material: data.Material,
          Plant,
        },
      ];

      const stockPricePayload = {
        N_PB2B_HEADER: [
          {
            Customer: BusinessPartner,
            SalesOrg,
          },
        ],
        N_PB2B_ITEMS_IN: itemInData,
        N_PB2B_ITEMS_OUT: [],
      };
      const stockQuantityResponse = await MainService.post(
        'ZAE_FM_PB2B_GET_AVL_QTY_MULTI_SRV/PB2B_GET_AVL_QTY_INPUTSet',
        stockQuantityPayload,
        stockQuantityRequestsConfig
      ).catch(err => console.log(err));
      const stockPriceResponse = await MainService.post(
        'ZAE_FM_PB2B_SIMULATE_GET_PRICE_SRV/ZAE_FM_PB2B_SIMULATE_GET_PRICESet',
        stockPricePayload,
        stockPriceRequestsConfig
      ).catch(err => console.log(err));
      const stockResults =
        stockQuantityResponse !== undefined
          ? stockQuantityResponse.data.d.N_PB2B_GET_AVL_QTY_OUTPUT.results
          : [];

      if (stockResults.length > 0) {
        const fD = stockResults.find(s => s.Material === data.Material);
        data = {
          ...data,
          checked: false,
          ConditionQuantity: '1',
          ConditionQuantityUnit: 'EA',
          StockQuantity: parseInt(fD.AvlQty, 10),
          StockQuantityUOM: fD.Uom,
        };
      } else {
        data = {
          ...data,
          checked: false,
          ConditionQuantity: '1',
          ConditionQuantityUnit: 'EA',
          StockQuantity: undefined,
          StockQuantityUOM: undefined,
        };
      }
      if (stockPriceResponse && stockPriceResponse.data.d.N_PB2B_ITEMS_OUT.results.length > 0) {
        const sD = stockPriceResponse.data.d.N_PB2B_ITEMS_OUT.results[0];
        if (sD.Material === data.Material) {
          data = {
            ...data,
            checked: false,
            ConditionQuantity: sD.ReqQty,
            ConditionQuantityUnit: sD.SalesUnit,
            SalesPrice: roundToTwoDecimals(sD.GrossPrice),
            SalesPriceUnit: sD.Currency,
          };
        }
      } else {
        data = {
          ...data,
          checked: false,
          ConditionQuantity: '1',
          ConditionQuantityUnit: 'EA',
          SalesPrice: undefined,
          SalesPriceUnit: undefined,
        };
      }

      dispatch({
        type: GET_ITEM_DATA,
        payload: {
          selItem: item,
          selItemData: data,
          isItemLoading: false,
        },
      });
    }
    throw new CustomException(invalidResponseMsgText);
  } catch (error) {
    dispatch({
      type: SET_ITEM_STATUS,
      payload: { isItemLoading: false },
    });
  }
};

export const resetItemData = () => ({ type: RESET_ITEM_DATA });

export const getMaterialGroupTableData = (enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, materialGroupData } = auth;
    dispatch({
      type: SET_MATERIAL_GROUP_TABLE_STATUS,
      payload: { isMaterialLoading: true },
    });
    const materialGroupFilterArr = [];
    let materialGroupFilter = '';
    materialGroupData.forEach(m => {
      materialGroupFilterArr.push(`MaterialGroup eq '${m.Matkl}'`);
    });
    if (materialGroupFilterArr.length > 0) {
      materialGroupFilter = materialGroupFilterArr.join(' or ');
    }
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $top: 20,
        'sap-client': client,
      },
    };

    if (materialGroupFilter !== '') {
      config.params.$filter = materialGroupFilter;
    }
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });
    const response = await MainService.get('/I_MaterialGroup', config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const data = genPickerData({
        data: response.data.d.results,
        config: {
          idFunc: ({ MaterialGroup }) => MaterialGroup,
          labelFunc: ({ MaterialGroup_Text }) => MaterialGroup_Text,
          valueFunc: ({ MaterialGroup }) => MaterialGroup,
        },
      });
      dispatch({
        type: GET_MATERIAL_GROUP_TABLE_DATA,
        payload: {
          data,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_MATERIAL_GROUP_TABLE_STATUS,
      payload: { isMaterialLoading: false },
    });

    enqueueSnackbar(i18n.t('productScreenTranslations:UNABLE_TO_LOAD_FILTER_DATA'), {
      variant: 'error',
    });
  }
};

// export const getAllProductsData = (skip, enqueueSnackbar = () => {}, filterStr = '') => async (
//   dispatch,
//   getState
// ) => {
//   try {
//     const state = getState();
//     const { auth } = state;
//     const { client, systemIP, selectedSalesOrgData } = auth;
//     const { SalesOrg, DisCha } = selectedSalesOrgData;
//     const idToken = await getIdToken(dispatch, getState);
//     let config = {
//       headers: {
//         'AZURE-AUTH': `${idToken}`,
//       },
//       params: {
//         'sap-client': client,
//         $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}'`,
//       },
//     };

//     if (filterStr !== '') {
//       config = {
//         ...config,
//         params: {
//           ...config.params,
//           $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and (${filterStr})`,
//         },
//       };
//     }

//     config.params = {
//       ...config.params,
//       $skip: skip,
//     };

//     const MainService = axios.create({
//       baseURL: `${systemIP}/ZAE_PB2B_SRV`,
//     });
//     const response = await MainService.get('/ZAE_I_Material_07', config).catch(throwSAPError);
//     if (isResponseValid(response)) {
//       const Data = response.data.d.results.map(r => ({
//         Material: r.Material,
//         'Material Group': r.MaterialGroupName,
//         'SuperSeeded Part No': r.ConcatSuperMaterials,
//         Quantity: r.Quantity,
//         'Gross Weight': r.MaterialGrossWeight,
//         'Material Name': r.MaterialName,
//         'Stock Quantity': r.StockQuantity,
//         Price: r.SalesPrice,
//         Tax: r.Tax,
//         'Net Value':
//           Number.isNaN(parseFloat(r.Tax)) ||
//           Number.isNaN(parseFloat(r.SalesPrice)) ||
//           Number.isNaN(parseFloat(r.Quantity))
//             ? ''
//             : (parseFloat(r.Tax) + parseFloat(r.SalesPrice)) * parseFloat(r.Quantity),
//       }));
//       Data.sort((a, b) => b.Material - a.Material);
//       downloadExcel(Data, 'AllProducts.xlsx', 'Products');
//     } else {
//       throw new CustomException(i18n.t('productScreenTranslations:INVALID_RESPONSE'));
//     }
//   } catch (error) {
//     dispatch({
//       type: GET_ITEM_LIST_DATA,
//       payload: {
//         isLoading: false,
//         failText: i18n.t('productScreenTranslations:UNABLE_TO_LOAD_PRODUCTS_DATA'),
//       },
//     });

//     enqueueSnackbar(i18n.t('productScreenTranslations:UNABLE_TO_LOAD_PRODUCTS_DATA'), {
//       variant: 'error',
//     });
//   }
// };

export const resetTableData = () => ({ type: RESET_ITEM_TABLE_LIST_DATA });

export const updateTableData = data => ({
  type: GET_ITEM_LIST_DATA,
  payload: {
    itemList: data,
    listCount: data.length,
    failText: '',
    field: 'itemTableList',
  },
});
